export enum DialogTitles {
  CREATE_VIEWING_GROUP = "Create Viewing Group",
  EDIT_VIEWING_GROUP = "Edit Viewing Group",
  VIEW_VIEWING_GROUP = "Viewing Group Details",
}
